import Layout from 'components/Layout';
import {
  IEndToEndContainer,
  EndToEndContainer as EndToEndSection,
} from 'containers/Solutions/EndToEndContainer';
import {
  HeroContainer as HeroSection,
  ISolutionsHeroContainer,
} from 'containers/Solutions/Hero';
import { IStatisticsContainer } from 'containers/Solutions/StatisticsContainer';
import { graphql } from 'gatsby';
import React, { LazyExoticComponent, lazy } from 'react';
import { IContentWithImage, IPartnerContainer } from 'utils/types/index';

import { SEO } from '../components/SEO';

const PartnerSection = lazy(() => import('containers/PartnerContainer'));
const StatisticsSection = lazy(
  () => import('containers/Solutions/StatisticsContainer'),
);

const components: {
  HeroSection: React.FC<ISolutionsHeroContainer>;
  EndToEndSection: React.FC<IEndToEndContainer>;
  PartnerSection: LazyExoticComponent<React.FC<IPartnerContainer>>;
  StatisticsSection: LazyExoticComponent<React.FC<IStatisticsContainer>>;
} = {
  EndToEndSection,
  HeroSection,
  StatisticsSection,
  PartnerSection,
};

type Props = {
  data: {
    clinicalTrialsContent: {
      title: string;
      heroSection: {
        headline: string;
        backgroundColor?: string;
      };
      sections: {
        componentName: string;
        headline: string;
        description?: { description: string };
        slug: string;
        title?: string;
        disclaimer: {
          id: string;
          internal: {
            content: string;
          };
        };
        childMarkdownRemark: {
          rawMarkdownBody: string;
        };
        listOfContentWithImages?: Array<IContentWithImage>;
      }[];
    };
  };
};

export const Head = () => <SEO />;

export const healthPlanPage = (props: Props) => {
  const { data } = props;
  const { clinicalTrialsContent } = data;
  const { heroSection, sections, title } = clinicalTrialsContent;

  return (
    <Layout>
      <HeroSection content={heroSection} title={title} />
      {sections.map((section, i: number) => {
        // @ts-ignore
        if (components[section.componentName]) {
          return React.createElement(
            // @ts-ignore
            components[section.componentName],
            {
              content: section,
              key: `${section.componentName}-${i}`,
            },
          );
        }
        return null;
      })}
    </Layout>
  );
};

export default healthPlanPage;

export const data = graphql`
  query {
    clinicalTrialsContent: contentfulPage(
      pageId: { eq: "EHSClinicalTrialsPage" }
    ) {
      title
      heroSection {
        headline
        description {
          description
        }
        componentName
        backgroundColor
        cta {
          text
          url
        }
        desktopImage {
          title
          gatsbyImageData(
            placeholder: BLURRED
            layout: FULL_WIDTH
            quality: 75
            resizingBehavior: FILL
            cropFocus: FACE
          )
        }
      }
      sections {
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        disclaimer {
          id
          internal {
            content
          }
          childMarkdownRemark {
            rawMarkdownBody
          }
        }
        sectionImage {
          title
          gatsbyImageData(placeholder: BLURRED, quality: 75)
        }
        cta {
          text
          url
        }
        listOfContentWithImages {
          ... on ContentfulContentWithImage {
            title
            heading
            backgroundColor
            description {
              description
            }
            slug
            cta {
              text
              url
            }
            image {
              title
              url
              gatsbyImageData(placeholder: BLURRED, quality: 75)
            }
          }
        }
      }
    }
  }
`;
